import algolialite from 'algoliasearch/lite'

/**
 * search only priveledge
 * @clientonly
 */
const clientClient = algolialite(
  process.env.NEXT_PUBLIC_ALGOLIA_APP_ID as string,
  process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_ONLY_API_KEY as string)

/**
 * search only priveledge
 * @clientonly
 */
// const initClientIndex = (index: AlgoliaIndexes) => clientClient.initIndex(index)

export default clientClient
